import { render, staticRenderFns } from "./ViewPosts.vue?vue&type=template&id=dcddb09a&scoped=true&"
import script from "./ViewPosts.vue?vue&type=script&lang=js&"
export * from "./ViewPosts.vue?vue&type=script&lang=js&"
import style0 from "./ViewPosts.vue?vue&type=style&index=0&id=dcddb09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcddb09a",
  null
  
)

component.options.__file = "ViewPosts.vue"
export default component.exports